import { FACTOR_CENTIMETER_MILLIMETER } from '../../constants';
import { ArticleDefinition } from '../Article';
import { LogisticsStatus } from '../LogisticsStatus';
import { SocketType } from '../SocketType';

export class ArticleDefinitionMapper {
  static toDomain = ({
    number,
    width,
    socketType,
    logisticsStatus,
    articleId,
    ...rest
  }: CoreServiceAPI.ArticleDto): ArticleDefinition => ({
    articleId,
    number,
    width: width && width / FACTOR_CENTIMETER_MILLIMETER,
    socketType: SocketType[socketType],
    logisticsStatus: LogisticsStatus[logisticsStatus],
    ...rest,
  });
}
